import { render, staticRenderFns } from "./FormDefaultImageCapture.vue?vue&type=template&id=32c37a52&scoped=true"
import script from "./FormDefaultImageCapture.vue?vue&type=script&lang=js"
export * from "./FormDefaultImageCapture.vue?vue&type=script&lang=js"
import style0 from "./FormDefaultImageCapture.vue?vue&type=style&index=0&id=32c37a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c37a52",
  null
  
)

export default component.exports